function e(e,t,{checkForDefaultPrevented:n=!0}={}){return function(r){if(e?.(r),!1===n||!r.defaultPrevented)return t?.(r)}}export{e as composeEventHandlers};
//# sourceMappingURL=index.js.map
